module.exports = __webpack_public_path__ + "Pallicharantej-6f2443b5.webp";